import { isEmpty } from 'lodash';
import { ELECTION_FIELD_DATA, electionFieldConfigKeys } from '~/consts/generalSettings';
import { ElectionAttribute } from '~/definitions/election';

function getSelectedElectionUpdateAttributes(attributes: ElectionAttribute[], number?: string, value?: string) {
    const attributesToUpdate: ElectionAttribute[] = [];

    attributes.forEach((attr: ElectionAttribute) => {
        let attribute: ElectionAttribute = {};

        electionFieldConfigKeys.forEach((key) => {
            const field = ELECTION_FIELD_DATA[key];
            if (attr.number === field.name) {
                attribute = { ...attr, value: attr?.value || '' };
            }
        });

        if (number) {
            const field = ELECTION_FIELD_DATA[number as string];
            if (attr.number === field.name) {
                attribute = { ...attribute, value: value || '' };
            }
        }

        if (!isEmpty(attribute)) {
            attributesToUpdate.push(attribute);
        }
    });

    return attributesToUpdate;
}

export default getSelectedElectionUpdateAttributes;
